export default __webpack_public_path__ + "static/img/boxyhq_logo.8c30486.png";